import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { AccessTemplateIdSelect } from './AccessTemplateIdSelect';
import { Input } from '../../../common/Input';
import { EmployeePickerField } from '../../../common/selectComponents/EmployeePicker';

function Register({
	showRegisterForm,
	closeRegisterForm,
	showEditForm,
	closeEditForm,

	username,
	setUsername,
	password,
	setPassword,
	confirmPassword,
	setConfirmPassword,
	employeePersonalInformationId,
	employeePersonalInformationFullName,
	employeeId,
	accessTemplateId,
	setAccessTemplateId,

	handleSubmit,
	handleUpdate,
	handleSelectEmployee,

}) {
	return (
		<>
			<RegisterForm
				isOpen={showRegisterForm}
				onClose={closeRegisterForm}
				username={username}
				setUsername={setUsername}
				password={password}
				setPassword={setPassword}
				confirmPassword={confirmPassword}
				setConfirmPassword={setConfirmPassword}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={employeePersonalInformationFullName}
				employeeId={employeeId}               // ADDED
				accessTemplateId={accessTemplateId}
				setAccessTemplateId={setAccessTemplateId}
				handleSubmit={handleSubmit}
				handleSelectEmployee={handleSelectEmployee}
			/>

			<EditForm
				isOpen={showEditForm}
				onClose={closeEditForm}
				username={username}
				employeePersonalInformationId={employeePersonalInformationId}
				employeePersonalInformationFullName={employeePersonalInformationFullName}
				employeeId={employeeId}               // ADDED
				accessTemplateId={accessTemplateId}
				setAccessTemplateId={setAccessTemplateId}
				handleUpdate={handleUpdate}
				handleSelectEmployee={handleSelectEmployee}
			/>
		</>
	)
}

function RegisterForm({
	isOpen,
	onClose,
	username,
	setUsername,
	password,
	setPassword,
	confirmPassword,
	setConfirmPassword,
	employeePersonalInformationId,
	employeePersonalInformationFullName,
	employeeId,           // ADDED
	accessTemplateId,
	setAccessTemplateId,
	handleSubmit,
	handleSelectEmployee
}) {
	const [errorState, setErrorState] = useState(false);
	const [isPasswordNotMatch, setIsPasswordNotMatch] = useState(false);

	const submit = (e) => {
		e.preventDefault();
		if (!username
			|| !password
			|| !confirmPassword
			|| !employeePersonalInformationId
			|| !accessTemplateId
		) {
			setErrorState(true);
			return;
		}

		if (password !== confirmPassword) {
			setIsPasswordNotMatch(true);
			return;
		}

		handleSubmit(e);
		setErrorState(false);
		setIsPasswordNotMatch(false);
	};

	const handleClose = () => {
		onClose();
		setErrorState(false);
		setIsPasswordNotMatch(false);
	};

	if (!isOpen) return null;

	return (
		<>
			<div className="fixed inset-0 z-[3000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
				{isOpen && (
					<div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
						<div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
							<h3 className="text-xl font-semibold text-blue-600">Register User</h3>
							<CloseIcon className="text-gray-400 hover:text-gray-700 cursor-pointer" onClick={() => handleClose()} />
						</div>
						<div className="p-6 overflow-y-auto flex-grow space-y-4">
							<div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm pb-4">
								<div className="py-1 border-b border-gray-300 mb-4">
									<h3 className="font-medium text-gray-700">User Credentials</h3>
								</div>
								<div className="space-y-4">
									<Input
										label="Username:"
										value={username}
										onChange={(e) => setUsername(e.target.value)}
										placeholder="Enter username"
										isRequired={true}
										error={errorState && !username}
										errorMessage="Please fill up this field"
									/>
									<Input
										label="Password:"
										type="password"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										placeholder="Enter password"
										isRequired={true}
										error={(errorState && !password) || isPasswordNotMatch}
										errorMessage={isPasswordNotMatch ? "Passwords don't match" : "Please fill up this field"}
									/>
									<Input
										label="Confirm Password:"
										type="password"
										value={confirmPassword}
										onChange={(e) => setConfirmPassword(e.target.value)}
										placeholder="Confirm password"
										isRequired={true}
										error={(errorState && !confirmPassword) || isPasswordNotMatch}
										errorMessage={isPasswordNotMatch ? "Passwords don't match" : "Please fill up this field"}
									/>

									{/* MODIFIED - now uses EmployeePickerField */}
									<EmployeePickerField
										label="Employee:"
										isRequired={true}
										employeePersonalInformationId={employeePersonalInformationId}
										displayValue={`${employeeId} - ${employeePersonalInformationFullName}`}
										onSelect={handleSelectEmployee}
										error={errorState && !employeePersonalInformationId}
										errorMessage="Please select an employee"
										allowClear={false}
									/>

									<AccessTemplateIdSelect
										label="Access Template:"
										isRequired={true}
										accessTemplateId={accessTemplateId}
										setAccessTemplateId={setAccessTemplateId}
										error={errorState && !accessTemplateId}
										errorMessage="Please select an access template"
									/>
								</div>
							</div>
						</div>
						<div className="flex justify-end space-x-2 p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
							<button className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
								onClick={() => handleClose()}>
								CANCEL
							</button>
							<button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
								onClick={(e) => submit(e)}>
								SAVE
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}

function EditForm({
	isOpen,
	onClose,
	username,
	employeePersonalInformationId,
	employeePersonalInformationFullName,
	employeeId,           // ADDED
	accessTemplateId,
	setAccessTemplateId,
	handleUpdate,
	handleSelectEmployee
}) {
	const [errorState, setErrorState] = useState(false);

	const submit = (e) => {
		e.preventDefault();
		if (!username
			|| !employeePersonalInformationId
			|| !accessTemplateId
		) {
			setErrorState(true);
			return;
		}

		handleUpdate(e);
		setErrorState(false);
	};

	const handleClose = () => {
		onClose();
		setErrorState(false);
	};

	if (!isOpen) return null;

	return (
		<>
			<div className="fixed inset-0 z-[3000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
				{isOpen && (
					<div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] xl:w-[40%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
						<div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
							<h3 className="text-xl font-semibold text-blue-600">Update User</h3>
							<CloseIcon className="text-gray-400 hover:text-gray-700 cursor-pointer" onClick={() => handleClose()} />
						</div>
						<div className="p-6 overflow-y-auto flex-grow space-y-4">
							<div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm pb-4">
								<div className="py-1 border-b border-gray-300 mb-4">
									<h3 className="font-medium text-gray-700">Account Information</h3>
								</div>
								<div className="space-y-4">
									<Input
										label="Username:"
										value={username}
										readOnly={true}
										isRequired={true}
										className="bg-gray-100 cursor-not-allowed"
									/>

									{/* MODIFIED - now uses EmployeePickerField */}
									<EmployeePickerField
										label="Employee:"
										isRequired={true}
										employeePersonalInformationId={employeePersonalInformationId}
										displayValue={`${employeeId} - ${employeePersonalInformationFullName}`}
										onSelect={handleSelectEmployee}
										error={errorState && !employeePersonalInformationId}
										errorMessage="Please select an employee"
										allowClear={false}
									/>
									
									<AccessTemplateIdSelect
										label="Access Template:"
										isRequired={true}
										accessTemplateId={accessTemplateId}
										setAccessTemplateId={setAccessTemplateId}
										error={errorState && !accessTemplateId}
										errorMessage="Please select an access template"
									/>
								</div>
							</div>
						</div>
						<div className="flex justify-end space-x-2 p-5 border-t border-gray-200 bg-white rounded-b-lg shadow-sm">
							<button className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
								onClick={() => handleClose()}>
								CANCEL
							</button>
							<button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
								onClick={(e) => submit(e)}>
								UPDATE
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default Register;